import axios from 'axios';
import formurlencoded from 'form-urlencoded';
import cookie from 'js-cookie';
import { getLocale } from '../helpers/index'

let token = cookie.get('access_token', { domain: process.env.REACT_APP_COOKIE_DOMAIN });

if (token) {
  axios.defaults.headers.Authorization = `bearer ${token}`
} else {
  axios.defaults.headers.Authorization = null;
}

let tokenExternal = cookie.get('araciste.integration.user.token', { domain: process.env.REACT_APP_COOKIE_DOMAIN });

if (tokenExternal) {
  axios.defaults.headers['external_token'] = `${tokenExternal}`
}

axios.defaults.headers['Accept-Language'] = getLocale();


class Proxy {
  constructor(endpoint = '', parameters = {}) {
    this.endpoint = endpoint;
    this.parameters = parameters;
  }

  getParameterString(obj, prefix) {
    var str = [], p;
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + "[" + p + "]" : p,
          v = obj[p];
        str.push((v !== null && typeof v === "object") ?
          this.getParameterString(v, k) :
          encodeURIComponent(k) + "=" + encodeURIComponent(v));
      }
    }
    return str.join("&");
  }

  submit(requestType, url, data = null, _headers = null) {

    return new Promise((resolve, reject) => {
      let str = this.getParameterString(this.parameters);
      let options = _headers ? { headers: _headers } : null;
      axios[requestType](this.endpoint + url + (str !== '' ? `?${str}` : ''), data, options).then(response => {
        resolve(response.data);
      }).catch(error => {
        if (error && error.response) {
          if (error.response.status === 401) {
            let refreshToken = cookie.get('refresh_token');
            if (refreshToken) {
              let body = {
                'grant_type': 'refresh_token',
                'refresh_token': refreshToken
              };
              let headers = {
                'Content-Type': 'application/x-www-form-urlencoded'
              };
              delete axios.defaults.headers.Authorization;
              axios.post(`${this.endpoint}/token`, formurlencoded(body), { headers: headers }).then(response => {
                cookie.set('access_token', response.data.access_token);
                axios.defaults.headers.Authorization = `bearer ${response.data.access_token}`;
                this.submit(requestType, url, data).then(response => {
                  resolve(response);
                }).catch(error => {
                  reject(error);
                })
              }).catch(error => {
                cookie.remove('access_token');
                cookie.remove('refresh_token');
                cookie.remove('access_token_expire');
                cookie.remove('access_token_time');
                window.location.replace('/auth');
              });
            }
            else {
              cookie.remove('access_token');
              cookie.remove('refresh_token');
              cookie.remove('access_token_expire');
              cookie.remove('access_token_time');
              window.location.replace('/auth');
            }
          }else if (error.response.status === 400){
            reject(error.response);
          }
          else {
            reject(error.response.data);
          }
        }
        else {
          reject();
        }
      });
    });
  }

  submitLogin(requestType, url, data = null) {
    return new Promise((resolve, reject) => {
      let str = this.getParameterString(this.parameters);
      let headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };
      axios[requestType](this.endpoint + url + (str !== '' ? `?${str}` : ''), formurlencoded(data), { headers: headers }).then(response => {
        resolve(response.data);
        // cookie.set('access_token', response.data.access_token);
        // cookie.set('refresh_token', response.data.refresh_token);
        // cookie.set('access_token_expire', response.data.expires_in);
        // cookie.set('access_token', response.data.access_token, { secure: process.env.REACT_APP_COOKIE_DOMAIN_SECURE, domain: process.env.REACT_APP_COOKIE_DOMAIN });
        // cookie.set('refresh_token', response.data.refresh_token, { secure: process.env.REACT_APP_COOKIE_DOMAIN_SECURE, domain: process.env.REACT_APP_COOKIE_DOMAIN });
        // cookie.set('access_token_expire', response.data.expires_in, { secure: process.env.REACT_APP_COOKIE_DOMAIN_SECURE, domain: process.env.REACT_APP_COOKIE_DOMAIN });
        cookie.set('access_token', response.data.access_token, { domain: process.env.REACT_APP_COOKIE_DOMAIN });
        cookie.set('refresh_token', response.data.refresh_token, { domain: process.env.REACT_APP_COOKIE_DOMAIN });
        cookie.set('access_token_expire', response.data.expires_in, { domain: process.env.REACT_APP_COOKIE_DOMAIN });
      }).catch(error => {
        if (error && error.data) {
          reject(error.data);
        }
        else {
          reject(error);
        }
      });
    });
  }
  

  /* ---------------------------- @GLOBAL PROXIES --------------------------- */
  getAll(payload) {
    let endpoint = `/${payload.keyOne}`;
    if (payload.idOne) {
      endpoint += `/${payload.idOne}`;
    }
    if (payload.keyTwo) {
      endpoint += `/${payload.keyTwo}`;
    }
    return this.submit('get', `${endpoint}`);
  }

  getSingle(payload) {
    let endpoint = `/${payload.keyOne}`;
    if (payload.idOne) {
      endpoint += `/${payload.idOne}`;
    }
    if (payload.keyTwo) {
      endpoint += `/${payload.keyTwo}`;
    }
    if (payload.idTwo) {
      endpoint += `/${payload.idTwo}`;
    }
    return this.submit('get', `${endpoint}`);
  }

  add(payload) {
    let endpoint = `/${payload.keyOne}`;
    if (payload.idOne) {
      endpoint += `/${payload.idOne}`;
    }
    if (payload.keyTwo) {
      endpoint += `/${payload.keyTwo}`;
    }
    return this.submit('post', `${endpoint}`, payload.data);
  }

  update(payload) {
    let endpoint = `/${payload.keyOne}`;
    if (payload.idOne) {
      endpoint += `/${payload.idOne}`;
    }
    if (payload.keyTwo) {
      endpoint += `/${payload.keyTwo}`;
    }
    if (payload.idTwo) {
      endpoint += `/${payload.idTwo}`;
    }
    return this.submit('patch', `${endpoint}`, payload.data);
  }

  delete(payload) {
    let endpoint = `/${payload.keyOne}`;
    if (payload.idOne) {
      endpoint += `/${payload.idOne}`;
    }
    if (payload.keyTwo) {
      endpoint += `/${payload.keyTwo}`;
    }
    if (payload.idTwo) {
      endpoint += `/${payload.idTwo}`;
    }
    return this.submit('delete', `${endpoint}`, payload.data);
  }
}

export default Proxy;



// WEBPACK FOOTER //
// ./src/proxies/Proxy.js